<template>
	<div v-if="profileData" :class="['headsup-display', { disabled: disabled }]">
		<ja-headsup-control-buttons
			class="mb--4"
			:complete-life-stage-button-disabled="completeLifeStageButtonDisabled"
			:finalize-shopping-visibility="finalizeShoppingVisibility"
			:disabled="disabled"
			@toggleCompleteLSBtnState="$emit('toggleCompleteLSBtnState')"
			@toggleFinalizeBudgetModal="$emit('toggleFinalizeBudgetModal')"
			@toggleFinalizeShoppingModal="$emit('toggleFinalizeShoppingModal')"
		/>
		<ja-hud-shape>
			<ja-budget-counter
				class="progress-bar budget-tracker"
				:tabindex="disabled ? -1 : 0"
				:disabled="disabled"
				role="button"
				:is-link="true"
				@click.native="openProfile"
				@keydown.native.enter="openProfile"
				@keydown.native.space="openProfile"
				@mousedown.prevent
			>
			</ja-budget-counter>
			<ja-avatar
				class="avatar"
				:size="128"
				:aria-label="profileStatusLabel"
				:tabindex="disabled ? -1 : 0"
				role="button"
				:disabled="disabled"
				@click.native="openProfile"
				@keydown.native.enter="openProfile"
				@keydown.native.space="openProfile"
				@mousedown.prevent
			></ja-avatar>
			<ja-financial-health
				v-if="!profileData.isEntryVirtualSimulationType"
				class="progress-bar financial-health"
				:tabindex="disabled ? -1 : 0"
				:is-link="true"
				role="button"
				:disabled="disabled"
				@click.native="openProfile"
				@keydown.native.enter="openProfile"
				@keydown.native.space="openProfile"
				@mousedown.prevent
			>
			</ja-financial-health>
		</ja-hud-shape>
		<div
			v-if="showFutureChoices"
			class="future-progress-tracker"
			aria-hidden="true"
		>
			<ja-future-tracker
				:children="profileData.studentChildren"
				:num-pets="profileData.numberOfPets"
				:married="isMarried"
			></ja-future-tracker>
		</div>
	</div>
</template>
<script>
import ProfileData from '@/mixins/ProfileData';
// import LifeStageData from '@/mixins/LifeStageData';
import Avatar from '../ui/Avatar';
import HudShape from './HudShape';
import FutureTracker from './FutureTracker';
import BudgetCounter from '../Metrics/BudgetCounter';
import FinancialHealth from '../Metrics/FinancialHealthMeter';
import HeadsupControlButtons from './HeadsupControlButtons';

// import UserData from '@/mixins/UserData';

export default {
	components: {
		jaAvatar: Avatar,
		jaHudShape: HudShape,
		jaFutureTracker: FutureTracker,
		jaBudgetCounter: BudgetCounter,
		jaFinancialHealth: FinancialHealth,
		jaHeadsupControlButtons: HeadsupControlButtons
	},
	mixins: [ProfileData],
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		completeLifeStageButtonDisabled: {
			type: Boolean,
			default: false
		},
		finalizeShoppingVisibility: {
			type: Boolean,
			default: false
		}
	},
	// data() {
	// 	return {
	// 		isCompleteButtonEnabled: false
	// 	};
	// },
	computed: {
		profileStatusLabel() {
			if (this.profileData) {
				const marriedStatus = this.isMarried
					? this.$t('married')
					: this.$t('notMarried');
				let childrenStatus = null;

				if (this.childrenCount == 0) {
					childrenStatus = this.$t('noChildren');
				} else {
					childrenStatus = `${this.childrenCount} ${
						this.childrenCount == 1 ? this.$t('child') : this.$t('children')
					}`;
				}
				let petStatus = null;

				if (this.profileData.numberOfPets == 0) {
					petStatus = this.$t('noPets');
				} else {
					petStatus = `${this.profileData.numberOfPets} ${
						this.profileData.numberOfPets == 1
							? this.$t('pet')
							: this.$t('pets')
					}`;
				}

				return this.$t('profileStatus', {
					marriedStatus,
					childrenStatus,
					petStatus
				});
			}
			return '';
		},
		showFutureChoices() {
			return (
				this.profileData &&
				(this.isMarried || this.childrenCount || this.profileData.numberOfPets)
			);
		}
		// showCompleteLifeStageButton() {
		// 	if (this.isInBudgetingPhase) {
		// 		return false;
		// 	}

		// 	const minMandatoryCategoriesPercentage = 100;
		// 	const completedLifeStagePercentage = 100;

		// 	return (
		// 		this.isCompleteButtonEnabled &&
		// 		this.profileData.cmsLifeStage.displayOrder > 1 &&
		// 		this.lifeStageData.mandatoryCategoriesCompletionPercentage >=
		// 			minMandatoryCategoriesPercentage &&
		// 		this.lifeStageData.currentLifeStageCompletionPercentage <
		// 			completedLifeStagePercentage
		// 	);
		// },
		// isFinalizeBudgetVisible() {
		// 	return this.$store.getters.areAllBudgetsSet && this.isInBudgetingPhase;
		// },
		// isFinalizeShoppingVisible() {
		// 	return this.finalizeShoppingVisibility;
		// }
	},
	// watch: {
	// 	showCompleteLifeStageButton(value) {
	// 		if (value) {
	// 			this.announceCompleteButton();
	// 		}
	// 	}
	// },
	created() {
		// LifeStageService.getSimCompleteLifeStageStatus(
		// 	this.userData.userActiveSimulationId
		// ).then(response => {
		// 	this.isCompleteButtonEnabled = response;
		// });
	},
	// mounted() {
	// 	if (this.showCompleteLifeStageButton) {
	// 		this.announceCompleteButton();
	// 	}
	// },
	methods: {
		// announceCompleteButton() {
		// 	setTimeout(() => {
		// 		if (!this.disabled) {
		// 			this.$announcer.polite(this.$t('completeButtonAppeared'));
		// 		}
		// 	}, 300);
		// },
		openProfile() {
			if (!this.disabled) {
				this.$store.commit('setLoading', true);
				this.$router.push({ name: 'profile' });
			}
		},
		// finishLifeStage() {
		// 	this.$emit('toggleCompleteLSBtnState');
		// },
		// finalizeBudget() {
		// 	this.$emit('toggleFinalizeBudgetModal');
		// },
		// finalizeShopping() {
		// 	this.$emit('toggleFinalizeShoppingModal');
		// },
		getSimCompleteLifeStageButton() {
			this.$store.dispatch('getSimulationCompleteLifeStageStatus');
		}
	}
};
</script>
<style lang="scss" scoped>
.headsup-display {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: linear-gradient(180deg, rgba(150, 174, 113, 0) 0%, #808b67 100%);
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	&.disabled {
		.avatar {
			&:hover {
				cursor: default;
			}
		}

		.progress-bar {
			&:hover {
				cursor: default;
			}
		}
	}

	// .gradient-button {
	// 	background: linear-gradient(123.25deg, #f82c5c 0%, #fcb98d 100%);
	// 	padding: 0px 26px;
	// 	border-radius: 25px;
	// 	color: #fff;
	// 	font-weight: bold;
	// 	font-size: 14px;
	// 	cursor: pointer;
	// 	text-decoration: none;
	// 	margin-bottom: 32px;
	// 	letter-spacing: 1px;

	// 	@media (min-width: $breakpoint-mid) {
	// 		font-size: 16px;
	// 	}
	// }

	.avatar {
		height: 128px;
		width: 128px;
		position: absolute;
		top: -8px;
		right: 0;
		left: 0;
		margin: auto;
		box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.33);
		&:hover {
			cursor: pointer;
		}
	}

	.progress-bar {
		width: 220px;
		height: 80px;
		padding: 8px;
		position: absolute;
		z-index: 2;
		top: 16px;
		white-space: nowrap;

		&:hover {
			cursor: pointer;
		}

		&.budget-tracker {
			left: 28px;

			::v-deep.bar-label {
				position: relative;
				right: 4px;
			}
		}

		&.financial-health {
			right: 28px;
			flex-direction: row-reverse;

			::v-deep.bar-label {
				position: relative;
				left: 8px;
			}
		}
	}

	.future-progress-tracker {
		margin-bottom: 32px;
	}
}
</style>
